/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Formats all URLs in a string into markdown syntax links
 *
 * @param {String} input The input to process.
 * @example
 *
 * formatTextLinks('viber://test.com');
 * // -> '[viber://test.com](viber://test.com)'
 *
 * formatTextLinks('https://google.com/');
 * // -> '[https://google.com/](https://google.com/)'
 *
 */

import { URL_REGEX } from '../../../constants/regex';

export default function formatTextLinks(input) {
  if (!input) {
    return;
  }
  const splitInput = input.split(' ');
  const formattedInput = [];

  for (const word of splitInput) {
    const isUrl = URL_REGEX.test(word);
    if (isUrl) {
      formattedInput.push(`[${word}](${word})`);
    } else {
      formattedInput.push(word);
    }
  }

  return formattedInput.join(' ');
}
